module.exports = __webpack_public_path__ + "static/media/who-14.74f2b401.jpg";